export const AMEX_USER_COHORT = 'AMEX_USER';
export const COMET_USER_COHORT = 'COMET_USER';
//# sourceMappingURL=constants.js.map